export enum FilePathValidationStatus {
    NO_ERROR,
    INVALID_CHARACTERS_ERROR,
    NOT_UNIQUE_ERROR,
    FILESERVER_NAME_IS_DEFAULT,
    FILESERVER_NAME_IS_BLOCKED,
    FILESERVER_NAME_IS_ADDED_IN_BRIDGE,
    FILESERVER_NAME_MAXIMUM_CHARACTERS,
    INVALID_DASHES_ERROR,
    INVALID_UNDERSCORES_ERROR,
    INVALID_FORMAT_ERROR
}
